module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"thankYouTitle":"Grazie per la tua Donazione!","download":"Scarica il file"},"en":{"thankYouTitle":"Thank you for your donation!","download":"Download the image"}}')
  delete Component.options._Ctor
}
